export default __webpack_public_path__ + "static/media/5BrokenTelephone.5b698182.png";